import { useFocusRing as useFocusRingAria } from '@react-aria/focus';

if (process.env.NODE_ENV === 'test') {
  if (typeof window !== 'undefined') {
    // @ts-expect-error
    window.MutationObserver = class {
      constructor() {
        this.disconnect = () => ({});
        this.observe = () => ({});
        this.takeRecords = () => [];
      }
      /** Stops observer from observing any mutations. Until the observe() method is used again, observer's callback will not be invoked. */
      disconnect: (() => {}) | undefined;
      observe: (() => {}) | undefined;
      /** Empties the record queue and returns what was in there. */
      takeRecords: (() => {}) | undefined;
    };

    global.MutationObserver = window.MutationObserver;
  }
}

export const useFocusRing = () => {
  const { isFocusVisible, focusProps } = useFocusRingAria();
  return { isFocusVisible, focusProps };
};
